// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social-icons{align-items:center;display:flex;flex-wrap:wrap;justify-content:center;list-style:none}.social-icons__icon:not(:last-child){margin-right:var(--spacing-default)}.social-icons .social-links__item-icon{background:#fff;height:16px;width:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
